export * from './baMenuItem.component';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baMenu/components/baMenuItem/index.ts